<template>
  <v-expansion-panels flat accordion v-model="panel" multiple>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.work_order_management') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="d-flex">
          <display-checkbox
            class="px-2"
            :label="
              generateMessage(
                'properties_360.fields.contractual_commitment.specific_workorder_group'
              )
            "
            :input-value="
              property.contractual_commitment.specific_workorder_group
            "
          />
          <display-checkbox
            class="px-2"
            :label="
              generateMessage(
                'properties_360.fields.contractual_commitment.extranetUnderValidation'
              )
            "
            :input-value="
              property.contractual_commitment.extranetUnderValidation
            "
          />
          <display-checkbox
            class="px-2"
            :label="
              generateMessage(
                'properties_360.fields.contractual_commitment.extranetCallingManagement'
              )
            "
            :input-value="
              property.contractual_commitment.extranetCallingManagement
            "
          />
        </div>
        <div class="d-flex">
          <div style="width: 50%" class="pa-2">
            <custom-simple-table
              :item="gestionFields"
              i18-path="properties_360.fields.contractual_commitment"
              :table-units="[
                'none',
                'none',
                'none',
                'none',
                'none',
                'none',
                'currency',
              ]"
              :table-keys="[
                'tech_in_charge',
                'request_unique_phone',
                'request_comment',
                'included_labor_hours',
                'included_interventions',
                'supplies_included',
                'amount_supplies_included',
              ]"
            />
          </div>
          <div style="width: 50%" class="d-flex flex-column pa-2">
            <custom-simple-table
              :item="property.contractual_commitment"
              i18-path="properties_360.fields.contractual_commitment"
              :table-keys="['customer_name', 'customer_type', 'customer_phone']"
            />
            <maintenance-contract-infos />
          </div>
        </div>
      </v-expansion-panel-content>
    </display-expansion-panel>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.orders') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <custom-simple-table
          :item="property"
          i18-path="properties_360.fields"
          :table-keys="[
            'reactive_instructions',
            'operator_instructions',
            'dispatcher_instructions',
          ]"
        />
      </v-expansion-panel-content>
    </display-expansion-panel>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.maintenance_plan') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table
          dense
          class="secondarybackground"
          no-data-text="Aucun plan associé à cette installation"
          :headers="planHeaders"
          :items="plans"
          disable-pagination
          hide-default-footer
        ></v-data-table>
      </v-expansion-panel-content>
    </display-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import DisplayCheckbox from '@/components/displays/DisplayCheckbox';
import { mapGetters } from 'vuex';
import { generateMessage } from '@/utils/i18n';
import DisplayExpansionPanel from '@/components/displays/panels/DisplayExpansionPanel';
import DisplayExpansionPanelHeader from '@/components/displays/panels/DisplayExpansionPanelHeader';
import MaintenanceContractInfos from './MaintenanceContractInfos';

export default {
  name: 'MaintenanceOperationsTab',
  components: {
    DisplayExpansionPanelHeader,
    DisplayExpansionPanel,
    CustomSimpleTable,
    DisplayCheckbox,
    MaintenanceContractInfos,
  },
  computed: {
    ...mapGetters({
      property: 'properties_360/current',
      plans: 'properties_360/maintenance_plan/items',
    }),
    gestionFields() {
      return {
        ...this.property.contractual_commitment,
        tech_in_charge: this.property.maintenance.tech_in_charge,
      };
    },
  },
  methods: {
    generateMessage,
  },
  data() {
    return {
      panel: [0],
      planHeaders: [
        { text: 'Libellé', value: 'description' },
        { text: 'Type', value: 'type_description' },
        { text: 'Fréquence', value: 'freq' },
        { text: "Nombre d'interventions", value: 'nbr_itv' },
      ].map((item) => {
        return { ...item, class: 'secondarybackground' };
      }),
    };
  },
};
</script>
